import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import AboutItem from './AboutItem';
import './Description.scss';

interface IDescriptionProps {
  context?: IContent;
}

const Description = ({ context }: IDescriptionProps) => {
  return (
    <section className="about_ubisoft-plus">
      <div className="ncsa-custom_container">
        <h2>{context.about_title}</h2>
        <div className="about_ubisoft-plus_boxes">
          {context.about_list.map((item, index) => (
            <AboutItem item={item} key={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default withContent(Description);
